import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode is intentionally not used here because react-leaflet
// 4 re-initialises its map container on the second effect pass and throws
// "Map container is already initialized." StrictMode is a dev-only no-op in
// production builds, so this only affects dev behaviour.
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// Register the PWA service worker (offline shell + push notifications).
// No-op on non-HTTPS/localhost or unsupported browsers.
registerServiceWorker();
